<div id="home">
  <app-store-widget-container></app-store-widget-container>
  <app-accumulated-totals-container></app-accumulated-totals-container>
</div>
